module.exports = __webpack_public_path__ + "static/img/7.8098af8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/7.png
// module id = bz+u
// module chunks = 0